module.exports = __webpack_public_path__ + "img/diet-coke.605a53d9.png";